<template>
  <div class="col-12">
    <ReferralProgram
      :referralProgramId="this.$route.query.referral_program"
      :userId="this.$route.query.user"
      :rewardId="this.$route.query.reward"
    />
  </div>
</template>
<script>
import ReferralProgram from "@/components/ReferralProgram.vue";

export default {
  components: {
    ReferralProgram
  }
};
</script>
